if (!customElements.get('origin-accessory')) {
  customElements.define('origin-accessory', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const image = this.querySelector('[data-accessory-image]');
      const color = this.querySelector('[data-accessory-color]');
      const price = this.querySelector('[data-accessory-price]');
      const buy = this.querySelector('[data-accessory-buy]');
      const quantity = this.querySelector('[name="quantity"]');
      const form = this.querySelector('form');
      let adding = false;
      form.addEventListener('submit', async event => {
        if (!globalThis.OriginCart) return;
        event.preventDefault();
        if (adding || !form.reportValidity()) return;
        adding = true;
        buy.disabled = true;
        try {
          const route = globalThis.Shopify?.routes?.root || '/';
          const response = await fetch(route + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          if (!response.ok) {
            const result = await response.json();
            const error = new Error(result.description || result.message);
            error.rejected = true;
            throw error;
          }
          await globalThis.OriginCart.open();
          adding = false;
          buy.disabled = false;
        } catch (error) {
          // Avoid a second add after an uncertain response.
          await globalThis.OriginCart.open(error.message);
          if (error.rejected) {
            adding = false;
            buy.disabled = false;
          }
        }
      });

      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-quantity-step]');
        if (!step) return;
        const current = Number.parseInt(quantity.value, 10) || 1;
        const maximum = Number(quantity.max) || Infinity;
        quantity.value = Math.min(maximum, Math.max(1, current + Number(step.dataset.quantityStep)));
      });

      this.addEventListener('change', (event) => {
        const option = event.target;
        if (!option.matches('input[type="radio"][data-image]')) return;
        image.src = option.dataset.image;
        image.alt = option.dataset.alt;
        color.textContent = option.dataset.color;
        price.textContent = option.dataset.price;
        const available = option.dataset.available === 'true';
        buy.disabled = !available || adding;
        buy.textContent = available ? buy.dataset.availableLabel : buy.dataset.unavailableLabel;
        quantity.max = option.dataset.stock;
        if (quantity.max) quantity.value = Math.max(1, Math.min(Number(quantity.value) || 1, Number(quantity.max)));
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState(history.state, '', url);
      });
    }
  });
}
